import axiosPost from "./axiosPost";

export const RNHComponenteSecundarioIns = async (credentials, data) => {
    const body = {
        service: "RNHComponenteSecundarioIns",
        params: {
            rnhComponenteSecundarioCod: data?.cod || null,
            rnhComponenteSecundarioNombre: data?.name || null,
            rnhComponenteSecundarioDescripcion: data?.desc || null
        },
    };

    const result = await axiosPost(body, credentials);
    if(result?.status?.code === 0) {
        return [result.status]
    } else {
        return result.result;
    }
};
